import { render, staticRenderFns } from "./EchartsfittingNum.vue?vue&type=template&id=32e356fe&"
import script from "./EchartsfittingNum.vue?vue&type=script&lang=js&"
export * from "./EchartsfittingNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports